<template>
  <div class="comp-psap-card-contacts">
    <div
    v-bind:class="{
      blue: contactList.length > 0
    }"
    class="cards-category">
      <comp-icon
      v-bind:icon="'contacts'"
      v-bind:width="24"></comp-icon>
      <span style="margin-left: 0.2em;">Contacts</span>
    </div>
    <template v-if="contactList.length > 0">
      <div
      v-on:click="onClickContact(contact)" ontouchstart=""
      v-for="(contact, index) in contactList"
      v-bind:key="index"
      class="card-container">
        <div class="info-item-icon">
          <comp-icon
          v-bind:icon="'person'"
          v-bind:width="36"></comp-icon>
        </div>
        <div class="info-item-text">
          <div class="name">{{contact.name}}</div>
          <div class="title">{{contact.title}}</div>
          <div class="phone">{{contact.phone}}</div>
          <div class="email">{{contact.email}}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="no-info">No information</div>
    </template>
  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
export default {
  name: 'comp-psap-card-contacts',
  components: {
    CompIcon
  },
  computed: {
    psapContacts: function () {
      return this.$store.getters.psapContacts
    }
  },
  data: function () {
    return {
      contactList: []
    }
  },
  watch: {
    psapContacts: function () {
      this.updateContactList()
    }
  },
  created: function () {
    this.updateContactList()
  },
  methods: {
    updateContactList: function () {
      if (this.psapContacts instanceof Array) {
        this.contactList = []
        this.psapContacts.map(contactInfo => {
          this.contactList.push({
            name: contactInfo.name,
            title: contactInfo.title,
            phone: contactInfo.phone,
            email: contactInfo.email,
            slotNumber: contactInfo.slotNumber
          })
        })
      }
    },
    onClickContact: function (contactInfo) {
      this.$emit('onClickContact', {
        name: contactInfo.name,
        phone: contactInfo.phone,
        email: contactInfo.email
      })
    }
  }
}
</script>

<style scoped>
.comp-psap-card-contacts {
  /* common */
  overflow: hidden;
  /* text */
  text-align: left;
  /* size */
  margin: 3px;
  margin-top: 1em;
  /* shape */
  border-radius: 4px;
}

.comp-psap-card-contacts .cards-category {
  /* common */
  font-size: 0.8em;
  background-color: #333;
  color: #fff;
  /* text */
  text-transform: uppercase;
  font-weight: bold;
  /* size */
  padding: 0.5em;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
}
.comp-psap-card-contacts .cards-category.blue {
  /* common */
  background-color: hsla(202, 100%, 50%, 1);
}

.comp-psap-card-contacts .no-info {
  /* common */
  background-color: #fff;
  color: #aaa;
  /* size */
  height: 4em;
  padding: 0.5em;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.comp-psap-card-contacts .card-container {
  /* common */
  background-color: #fff;
  color: #000;
  /* mouse */
  cursor: pointer;
  /* size */
  border-top: 1px solid #ccc;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.comp-psap-card-contacts .card-container:hover {
  /* common */
  background-color: hsla(0, 0%, 95%, 1);
}

.comp-psap-card-contacts .card-container .info-item-icon {
  /* common */
  color: hsla(202, 100%, 50%, 1);
  background-color: hsla(0, 0%, 95%, 1);
  /* size */
  padding: 0.2em;
  /* position */
  margin-left: 0.5em;
  /* shape */
  border-radius: 50%;
  border: 1px solid hsla(0, 0%, 90%, 1);
}

.comp-psap-card-contacts .card-container .info-item-text {
  /* size */
  padding: 0.5em;
}
.comp-psap-card-contacts .card-container .info-item-text .name {
  /* common */
  font-size: 1em;
}
.comp-psap-card-contacts .card-container .info-item-text .title {
  /* common */
  font-size: 0.7em;
}
.comp-psap-card-contacts .card-container .info-item-text .phone {
  /* common */
  font-size: 0.7em;
}
.comp-psap-card-contacts .card-container .info-item-text .email {
  /* common */
  font-size: 0.7em;
}

</style>



// WEBPACK FOOTER //
// src/components/CompPsapCardContacts.vue